import { render, staticRenderFns } from "./RichTextDisplay.vue?vue&type=template&id=3b0af4e7&scoped=true&"
import script from "./RichTextDisplay.vue?vue&type=script&lang=js&"
export * from "./RichTextDisplay.vue?vue&type=script&lang=js&"
import style0 from "./RichTextDisplay.vue?vue&type=style&index=0&id=3b0af4e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0af4e7",
  null
  
)

export default component.exports